module.exports = __webpack_public_path__ + "img/img-6.f3b0931b.png";